var map = {
	"./video-carousel.de-CH.json": 1428,
	"./video-carousel.de-DE.json": 1429,
	"./video-carousel.en-CA.json": 1430,
	"./video-carousel.en-GB.json": 1431,
	"./video-carousel.en-IN.json": 1432,
	"./video-carousel.en-ME.json": 1433,
	"./video-carousel.en-US.json": 1434,
	"./video-carousel.es-EM.json": 1435,
	"./video-carousel.es-ES.json": 1436,
	"./video-carousel.fr-BE.json": 1437,
	"./video-carousel.fr-CA.json": 1438,
	"./video-carousel.fr-CH.json": 1439,
	"./video-carousel.nl-BE.json": 1440,
	"./video-carousel.nl-NL.json": 1441,
	"./video-carousel.pl-PL.json": 1442,
	"./video-carousel.pt-BR.json": 1443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1427;